import { css } from '@emotion/react';

export const useStyles = () => ({
  root: css`
    word-break: keep-all;
    overflow-wrap: normal;
  `,
});
